// 定义全局方法
/* eslint-disable */
import { Message } from 'element-ui'

export default {  
  install(Vue, options)
  {
    // 验证操作权限
    Vue.prototype.verifyRole = function(route) {
        let funs = JSON.parse(localStorage.funs)

        if (localStorage.role !== '1' && funs.indexOf(route) === -1) {
            Message('暂无权限')
            return false
        }

        return true
    };

    // 给字符串左边自动填补0
    Vue.prototype.preZeroFill = function(num, size) {
        if (num >= Math.pow(10, size)) {
            return num.toString();
        } else {
            var _str = Array(size + 1).join('0') + num;
            return _str.slice(_str.length - size);
        }
    };

    // 时间戳转格式化时间函数
    Vue.prototype.timeToDate = function (time, format='Y-m-d H:i:s', zone=0) {
        var date = new Date(parseInt(time+'000'))

        if (zone !== 0) {
            var Y = date.getFullYear()
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1)
            var D = this.preZeroFill(date.getDate(), 2)
            var h = this.preZeroFill(date.getHours(), 2)
            var m = this.preZeroFill(date.getMinutes(), 2)
            var s = this.preZeroFill(date.getSeconds(), 2)
        } else {
            var Y = date.getUTCFullYear()
            var month = date.getUTCMonth()+1
            var M = (month < 10 ? '0' + month : month)
            var D = this.preZeroFill(date.getUTCDate(), 2)
            var h = this.preZeroFill(date.getUTCHours(), 2)
            var m = this.preZeroFill(date.getUTCMinutes(), 2)
            var s = this.preZeroFill(date.getUTCSeconds(), 2)
        }

        var time = '';

        switch(format) {
            case 'Y-m-d':
                time = Y + "-" + M + "-" + D;
                break;
            case 'H:i:s':
                time = h + ":" + m + ":" + s;
                break;
            case 'YmdHis':
                time = Y+M+D+h+m+s;
                break;
            case 'Ymd':
                time = Y+M+D;
                break;
            case 'His':
                time = h+m+s;
                break;
            case 'Y/m/d':
                time = Y + "/" + M + "/" + D;
                break;
            default:
                time = Y + "-" + M + "-" + D + ' ' + h + ":" + m + ":" + s;
        }
        
        return time
    };

    // 格式化时间转时间戳
    Vue.prototype.dateToTime = function (date) {
        var time = date.getTime()
        // return Math.floor(time / 1000)
        return Math.floor(time / 1000) - (date.getTimezoneOffset())*60
    };

    // 根据时间（-7，-1，1，7，30等），获取时期
    Vue.prototype.dayToDate = function (day) {
        var days = new Date();

        //getTime()返回 1970 年 1 月 1 日至今的毫秒数。
        var gettimes = days.getTime() + 1000 * 60 * 60 * 24 * day;

        //setTime()以毫秒设置 Date 对象。
        days.setTime(gettimes); 
        var year = days.getFullYear();

        var month = days.getMonth()+1;
        if (month < 10) {
            month = "0" + month;
        }

        var today = days.getDate();
        if (today < 10) {
            today = "0" + today;
        }

        return year + "-" + month + "-" + today;
    };

    // 合并两个json对象
    Vue.prototype.combineObj = function (o,n) {
        for (var p in n) {
            if(n.hasOwnProperty(p) && (!o.hasOwnProperty(p)))
                o[p]=n[p]
        }
        return o
    };

    // 去掉对象中的空值
    Vue.prototype.clearEmptyObj = function (obj) {
        var box = {}

        for (var o in obj) {
            if (String(obj[o]).length) {
                box[o] = obj[o]
            }
        }
        return box
    };

    // 合并两个js一维数组，并去重
    Vue.prototype.combineOneObj = function(m, n) {
        var arr = []

        for (var a in m) {
            arr.push(m[a])
        }

        for (var b in n) {
            arr.push(n[b])
        }

        return unique(arr, true)
    };

    // js数组去重并排序
    function unique(array, isSorted) {
        var res = [];
        var seen = [];

        for (var i = 0, len = array.length; i < len; i++) {
            var value = array[i];
            if (isSorted) {
                if (!i || seen !== value) {
                    res.push(value)
                }
                seen = value;
            }
            else if (res.indexOf(value) === -1) {
                res.push(value);
            }        
        }
        return res;
    };

    // 判断json中是否包含某个键值
    Vue.prototype.indexOfJson = function (obj, value, key = '') {
        var k
        
        if (key) {
            for (k in obj) {
                if (obj[k][key] === value) {
                    return k
                }
            }
        } else {
            for (k in obj) {
                if (obj[k] === value) {
                    return k
                }
            }
        }
        
        return -1
    };

    // json数组对象重新排序
    Vue.prototype.jsonSort = function (obj) {
        var k
        var i = 0
        var sortObj = []

        for (k in obj) {
            sortObj[i] = obj[k]
            i++
        }
     
        return sortObj
    };

    // 生成唯一字符串（UUID）
    Vue.prototype.generateUUID = function () {
        var d = new Date().getTime()
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0
            d = Math.floor(d/16)
            return (c=='x' ? r : (r&0x7|0x8)).toString(16)
        })
        return uuid.replace(/-/g,'')
    };

    // 获取指定文件后缀
    Vue.prototype.getFileExt = function (file, str = ".") {
        var index= file.lastIndexOf(str)
        return  file.substr(index+1)
    };

    // 去掉指定字符串左右两边的空格
    Vue.prototype.strTrim = function (str) {
        var trimRegex = /^[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+|[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+$/g;
        return str.replace(trimRegex, "");
    };

    // 获取支付状态
    Vue.prototype.getPayType = function (type) {
        var types = {
            "0": "未支付",
            "1": "已支付",
            "2": "已取消",
            "3": "已过期",
            "4": "已删除"
        }

        return types[type]
    };

    // 获取支付方式
    Vue.prototype.getOrderStatus = function (type) {
        var types = {
            "0": "未支付",
            "1": "微信",
            "2": "支付宝",
            "3": "paypal"
        }

        return types[type]
    };
  }
}



// WEBPACK FOOTER //
// ./src/global/function.js